import { createSelector } from "@reduxjs/toolkit";

export const selectCycleState = (state) => state.cycle;

export const selectCycles = (state) => state.cycle.cycles;
export const selectPredictions = (state) => state.cycle.predictions;
export const selectFertilityWindow = (state) => state.cycle.fertilityWindow;
export const selectCycleSummary = (state) => state.cycle.summary;

export const selectCycleLoading = (state) => state.cycle.isLoading;
export const selectCycleError = (state) => state.cycle.errorMessage;

/* Composite selector */
export const selectCycleDashboard = createSelector(
  [selectCycles, selectPredictions, selectFertilityWindow, selectCycleSummary],
  (cycles, predictions, fertilityWindow, summary) => ({
    cycles,
    predictions,
    fertilityWindow,
    summary,
  })
);
